module.exports = __webpack_public_path__ + "img/f30f2cc.svg";